import * as types from '../actions/typeNames'
import { LOADER_VIEW } from '../actions/main'

const InitialState = {
    view: LOADER_VIEW,
    snackbarOpenSuccess: false,
    snackbarOpenError: false,
}

const form = (state=InitialState, action) => {
    switch(action.type){
        case types.SET_LOADER:
            return{...state, view:action.view, id: action.id, presId: action.presId} 
         
        case types.ON_SUBMIT_RESPONSE:
            return onSubmitResponse(state, action)
        default:
            return {...state};
    }
}

const onSubmitResponse = (state, action) => {
    let newState = {...state};
    switch(action.status){
        case 'success':
            newState.snackbarOpenSuccess = true;
            newState.snackbarOpenError = false;
            break;
        case 'error':
            newState.snackbarOpenSuccess = false;
            newState.snackbarOpenError = true;
            break;
        case 'catch':
            newState.snackbarOpenSuccess = false;
            newState.snackbarOpenError = true;
            break;
        default:
            newState.snackbarOpenSuccess = false;
            newState.snackbarOpenError = false;
            break;
    }
    return newState;
}

export default form;